module.exports = __webpack_public_path__ + "img/4h.cdc4917a.png";